import BaseApiClient from "./base-client";
// API Class
class StudiesApi extends BaseApiClient {
    BASE_PATH = "/api/studies";
    getStudies = () => this.get(this.BASE_PATH);
    setStudyExportSetting = (studyId, setting) => {
        this.post(`${this.BASE_PATH}/${studyId}/preferences/export-setting`, {
            data: setting
        });
        return new Promise((resolve) => resolve(setting));
    };
    getStudiesMetadata = () => this.get(`${this.BASE_PATH}/metadata`).then((res) => res.map((study) => ({
        ...study,
        state: study.state.toLowerCase(),
        studyType: study.studyType.toLowerCase()
    })));
    restoreStudy = (studyId) => this.post(`${this.BASE_PATH}/${studyId}/restore`);
    static instance = new StudiesApi();
}
export default StudiesApi.instance;
